import TooltipEllipsis from '@deltek/specification-client/core/Feedbacks/TooltipEllipsis'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import React from 'react'

const IsActiveCell = ({ value }: { value: any }) => {
    if (value === true || value === false) {
        return (
            <TooltipEllipsis text={value ? 'Active' : 'Inactive'}>
                <Typography
                    style={{
                        fontSize: pxToRem(14),
                        fontFamily: 'Roboto',
                    }}
                    noWrap
                >
                    {value ? 'Active' : 'Inactive'}
                </Typography>
            </TooltipEllipsis>
        )
    }
    return <></>
}

export default IsActiveCell
